import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openLeaveContactsModal } from '../../actions/leaveContacts/actions';
import { PricingSection } from '../../components/PricingSection';
import { selectPricingMethods } from '../../selectors/promoInfo';
import { trackScrollToCallToAction } from '../../utils/analytics/trackScrollToCallToAction';
import { pipe } from '../../utils/pipe';
import { IPriceData } from '../../types/priceData';
import { useApplicationContext } from '../../utils/applicationContext';
import { makeFileNotCacheable } from '../../utils/makeFileNotCacheable';

export const PRICE_LIST_URL = makeFileNotCacheable(
  'https://cdn.cian.site/frontend/e2e-form-assets/documents/e2e_deal_price_list.pdf',
);
export const FALLBACK_PRICE_DATA = {
  initialPrice: '3 900 ₽',
};

export const PricingSectionContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { config } = useApplicationContext();

  const priceData =
    config.get<IPriceData>('deal-sale-promo-frontend.priceData') || /* istanbul ignore next */ FALLBACK_PRICE_DATA;

  const onOpenLeaveContactsModal = () => dispatch(openLeaveContactsModal());

  const pricingMethods = useSelector(selectPricingMethods);

  return (
    <PricingSection
      onCreateDealButtonClick={pipe(() => trackScrollToCallToAction('price'), onOpenLeaveContactsModal)}
      pricingMethods={pricingMethods}
      priceData={priceData}
      priceListUrl={PRICE_LIST_URL}
    />
  );
};
